module.exports = __webpack_public_path__ + "img/su.ce27aa59.svg";